<template>
  <path pid="0" d="M21 3H5a3 3 0 00-3 3v10a3 3 0 003 3h1a1 1 0 000-2H5a1 1 0 01-1-1V6a1 1 0 011-1h16a1 1 0 011 1v10a1 1 0 01-1 1h-1a1 1 0 000 2h1a3 3 0 003-3V6a3 3 0 00-3-3z"/><path pid="1" d="M18 23a1 1 0 00.77-1.64l-5-6a1 1 0 00-1.54 0l-5 6A1 1 0 008 23zm-5-5.44L15.86 21h-5.72z"/>
</template>
